import { defineStore } from 'pinia'
import useCrudStore from '@/hooks/useCrudStore'
import { fetchItem, fetchItems } from '@/apps/traforama/api/versions'
import { IVersionsFilter } from '@/apps/traforama/interfaces/versions'

const defaultFilter: IVersionsFilter = {}

export const useVersionsStore = defineStore('versions', () => {
  const {
    currentItems,
    total,
    filter,
    items,
    listLoading,
    itemsLoading,
    currentPage,
    FetchItems,
    FetchItem,
    SetCurrentPage,
    SetFilters,
    error
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    fetchItem
  })

  return {
    items,
    currentItems,
    total,
    listLoading,
    itemsLoading,
    currentPage,

    FetchItems,
    FetchItem,
    SetCurrentPage,
    SetFilters
  }
})
